module.exports = __webpack_public_path__ + "static/3-Tri-12-81f56d2004bf47d4109862601a3d7b21.png";